import { colors, fonts } from './theme'
import useIsMobile from './hooks/useIsMobile'

export default function Masthead({ activeTab, onTabChange }) {
  const isMobile = useIsMobile()
  const now = new Date()
  const vol = now.getFullYear() - 2025 + 1
  const issue = Math.ceil((now.getMonth() + 1) * 30.4 / 7)

  const tabs = [
    { key: 'market', label: 'Market' },
    { key: 'institutions', label: 'Institutions' },
    { key: 'mechanics', label: 'Mechanics' },
    { key: 'risk_lab', label: 'Risk Lab' },
    { key: 'research', label: 'Research' },
  ]

  return (
    <header style={{ ...styles.header, ...(isMobile ? styles.headerMobile : {}) }}>
      <div style={styles.left}>
        <span style={{ ...styles.title, ...(isMobile ? styles.titleMobile : {}) }}>Markov Agents</span>
        {!isMobile && (
          <span style={styles.subtitle}>
            Private Credit Intelligence
          </span>
        )}
      </div>

      <nav style={{ ...styles.nav, ...(isMobile ? styles.navMobile : {}) }}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              ...styles.navItem,
              ...(isMobile ? styles.navItemMobile : {}),
              ...(activeTab === tab.key ? styles.navItemActive : {}),
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {!isMobile && (
        <div style={styles.right}>
          <span style={styles.meta}>
            Vol. {vol}, No. {issue}
          </span>
          <span style={styles.meta}>
            {now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </span>
        </div>
      )}
    </header>
  )
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 32px',
    borderBottom: `1px solid ${colors.rule}`,
    background: colors.navyDeep,
  },
  left: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 12,
  },
  title: {
    fontFamily: fonts.serif,
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: -0.3,
    color: colors.gold,
  },
  subtitle: {
    fontFamily: fonts.serif,
    fontSize: 12,
    fontStyle: 'italic',
    color: colors.textMuted,
  },
  nav: {
    display: 'flex',
    gap: 4,
  },
  navItem: {
    padding: '6px 16px',
    fontFamily: fonts.serif,
    fontSize: 13,
    fontWeight: 500,
    color: colors.textSecondary,
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: 2,
    cursor: 'pointer',
    transition: 'all 0.15s',
  },
  navItemActive: {
    color: colors.steel,
    borderColor: colors.steelBorder,
    background: colors.steelBg,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  meta: {
    fontFamily: fonts.serif,
    fontSize: 11,
    fontStyle: 'italic',
    color: colors.textMuted,
  },
  headerMobile: {
    padding: '8px 12px',
  },
  titleMobile: {
    fontSize: 16,
  },
  navMobile: {
    gap: 2,
  },
  navItemMobile: {
    padding: '4px 10px',
    fontSize: 11,
  },
}
